import React from 'react';
import { Authenticated } from '../auth';
import ViewExport from './ViewExport';

const SentExport = (props) => <ViewExport {...props} type="sent" />;
const ReceivedExport = (props) => <ViewExport {...props} type="received" />;

export default {
  path: 'export',
  name: 'Export',
  component: Authenticated,
  childRoutes: [
    {
      path: 'sent',
      component: SentExport,
    },
    {
      path: 'received',
      component: ReceivedExport,
    },
  ],
};
